import { AxiosResponse } from 'axios';

// Helper.
import API from '../Api';
// Types.
import { HubSpotBlog } from '../types/news';

export const fetchAlerts = async (): Promise<AxiosResponse> => {
  const faqs: AxiosResponse<HubSpotBlog[]> = await API({
    method: 'get',
    url: `/v1/alerts`,
  }).catch((error) => {
    if (error.response) {
      return error.response;
    }
  });

  return faqs;
};
